<template>
    <button @click="goDetail(product)" class="product-info opacity-0" :class="product + ' shift-' + shift + ' ' + isHovered">
        <div class="pulse-circle" v-if="touch && hover"></div>
        <div class="name">{{ $t( i18category + '.' + product ) }}</div>
        <div class="point"></div>
    </button>
</template>

<script>
export default {
    name: 'ListPoint',
    props: [
        'product',
        'shift',
        'i18category',
        'category',
        'childHover'
    ],
    data() {
        return {
            touch: false,
            hover: false,
        }
    },
    computed: {
        isHovered() {
            if(this.hover) {
                return 'hover'
            } else {
                return ''
            }
        }
    },
    watch: {
        childHover(val) {
            if(this.childHover = true) {
                this.hover = false;
            }
        }
    },
    methods: {
        goDetail(path) {
            if(!this.touch || this.hover) {
                this.$router.push({ path: '/' + this.category + '/' + path, query: { lang: this.$i18n.locale }});
            } else {
                this.$root.$emit('pointHover', true);
                this.hover = true;
            }
        },
        // check if device is touch device
        isTouchDevice() {
            try {
                document.createEvent("TouchEvent");
                return true;
            } catch (e) {
                return false;
            }
        }
    },
    mounted() {
        // set touch to true if touch device
        this.$data.touch = this.isTouchDevice();
        // check if other ListPoint is hovered
        this.$root.$on('pointHover', data => {
            this.$data.hover = false;
        });
    }
}
</script>